import loadable from '@loadable/component';
import Loading from '../../../components/Loader';
import { fetchTopic } from '../../../actions/topic';

const Topic = loadable(() => import(/* webpackChunkName: "topic" */ './Container'), {
  fallback: Loading
});

Topic.needs = (props, { dispatch }) => {
  const page = props.params.page;
  return dispatch(fetchTopic(props.params.topic, page));
};
export default Topic;
